import Typography from '../../Atoms/Typography';
import { Icon } from '../../Icons';
import { Controlled as CodeMirror } from 'react-codemirror2';
import Accordion from '../../Accordian/Accordian';
import InputRange from 'react-input-range';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/theme/abcdef.css';
import 'codemirror/theme/abbott.css';
import 'codemirror/theme/ayu-dark.css';
import 'codemirror/theme/3024-night.css';
import 'codemirror/theme/dracula.css';
import 'codemirror/theme/night.css';
import 'code-mirror-themes/themes/made-of-code.css';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/javascript/javascript';
import ZohoChatSupport from '../../Common/ZohoChartSupport';
import useOnboardingConfigurationYamlBased from '../../../hooks/Onboarding/configureTestYamlBased';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ViewTestResult from '../ViewTestResult';
import {
  staticTestRunnerCmdFramework,
  staticDiscoveryCmdFramework,
} from '../../../utils/onboarding/languageBasedConfig';
import { onlyWindowsSupportedFramework } from '../../../utils/onboarding/languageBasedConfig';
import history from 'utils/history';
import ReactTooltip from 'react-tooltip';
import 'react-input-range/lib/css/index.css';
import { sendAmplitudeEvents } from '../../../utils/common';
import { EventNames } from '../../../utils/events';
import { Path } from 'constants/routes';

import { isEnterPressed } from 'utils/keyboard';

function onGoBack() {
  window.history.state
    ? history.goBack()
    : history.push(Path.JOBS, {
        previous_page: Path.QUICK_START_YAML_BASED_TEST.Path,
      });
}

function ConfigureTestYamlBased() {
  let {
    currentConfiguration,
    currentConfigurationYamlBased,
    setActiveEventKeyAccordianUserSetting,
    setActiveEventKeyAccordianTimeout,
    activeEventKeyTimeout,
    activeEventKeyUserSetting,
    activeEventKeyHypertestCli,
    setActiveEventKeyHypertestCli,
    activeEventKeyTestDiscovery,
    setActiveEventKeyTestDiscovery,
    activeEventKeyTestRunner,
    setActiveEventKeyTestRunner,
    activeEventKeyTestRunCmd,
    setActiveEventKeyTestRunCmd,
    updateYaml,
    getYamlCode,
    textCopiedType,
    copyBtnClicked,
    downloadYaml,
    setPlatform,
    concurrency,
    changeConcurrency,
    changeRetry,
    changeTimeout,
    updateTestDiscovery,
    updateTestRunner,
    getCommandToRunTest,
    downloadConcierge,
    resetYamlCode,
    getSystemOsIcon,
    getSystemOsName,
    systemOS,
    getOthersOS,
    copyBtnClickedTestRunner,
    testRunnerCmdCopy,
    concurrencyInputFieldValue,
    retryInputFieldValue,
    timeoutInputFieldValue,
    visual,
    getConciergeURL,
    resetDownloadCociergeAlert,
    yamlCopied,
    yamlDownloaded,
    updateYamlCopyAlertStatus,
    updateCompletedSteps,
    promoBannerHeight,
  } = useOnboardingConfigurationYamlBased();
  let isLinuxSupported = true;
  if (
    onlyWindowsSupportedFramework.indexOf(
      currentConfiguration &&
        currentConfiguration.framework &&
        currentConfiguration.framework.name
    ) !== -1
  ) {
    isLinuxSupported = false;
  }
  return (
    <div className="ltw-bg-group-list-bg-color ltw-py-20px ltw-ml-10px run-on-local-page-container">
      <ReactTooltip id="configure-yaml" html={true} />
      <div className="ltw-flex ltw-items-center ltw-justify-between">
        <div className="ltw-mb-11px ltw-flex ltw-items-center">
          <Icon
            name={'back-icon'}
            width="10"
            height="16"
            onClick={onGoBack}
            className={'ltw-mr-18px ltw-inline-block ltw-cursor-pointer'}
          />
          <Typography
            variant="h2"
            fontSize="ltw-text-18"
            lineHeight="ltw-leading-22"
            fontType="ltw-font-semibold"
            color="ltw-text-black"
          >
            Configure your{' '}
            {currentConfiguration &&
              currentConfiguration.framework &&
              currentConfiguration.framework.name}{' '}
            script with HyperExecute
          </Typography>
        </div>
        <div className="ltw-flex ltw-items-center ltw-gap-11px">
          <Typography
            variant="h2"
            color="ltw-text-black-secondary"
            fontSize="ltw-text-14"
            lineHeight="ltw-leading-16"
            mr="12px"
          >
            Looking for Advance Configuration?
          </Typography>
          <div className="ltw-flex ltw-justify-between ltw-gap-15px">
            <ZohoChatSupport />
          </div>
        </div>
      </div>
      <div
        className={`ltw-flex ltw-gap-20px ltw-mt-30px ${
          promoBannerHeight > 0
            ? 'yamlBasedStepsContainerWithPromoBanner'
            : 'yamlBasedStepsContainer'
        }`}
      >
        <div className="ltw-flex-1 ltw-overflow-y-scroll ltw-p-10px">
          <div
            className="ltw-flex ltw-relative"
            disableddiv={
              currentConfigurationYamlBased.completedSteps.indexOf(
                'download_concierge'
              ) === -1 && currentConfigurationYamlBased.currentStep !== 1
                ? 'disabled'
                : 'false'
            }
          >
            <div
              className={`ltw-border-l ltw-border-dashed ltw-border-opacity-40 ${
                currentConfigurationYamlBased.completedSteps.indexOf(
                  'download_concierge'
                ) !== -1
                  ? 'ltw-border-primary'
                  : 'ltw-border-gray-7'
              } ltw-mt-40px `}
            >
              <span
                className={`ltw-border-2 ltw-rounded-5px ${
                  currentConfigurationYamlBased.currentStep === 1 ||
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'download_concierge'
                  ) !== -1
                    ? 'ltw-border-primary'
                    : 'ltw-border-gray-7'
                } ltw-w-8px ltw-h-8px ltw-absolute ltw-right-full ltw-left-minus4px ${
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'download_concierge'
                  ) !== -1
                    ? 'ltw-bg-primary'
                    : ' ltw-bg-white'
                }`}
              ></span>
            </div>
            <Accordion
              activeEventKey={activeEventKeyHypertestCli}
              onToggle={setActiveEventKeyHypertestCli}
              className="ltw-ml-18px ltw-p-20px ltw-mt-14px ltw-rounded-lg ltw-bg-white ltw-shadow-onboarding-step ltw-flex-1"
            >
              <Accordion.Toggle eventKey={0}>
                <div className="ltw-flex ltw-items-center">
                  <div className="ltw-flex-1 ltw-cursor-pointer">
                    <div className="ltw-flex ltw-gap-8px ltw-items-center">
                      <Typography
                        variant="h2"
                        fontType="ltw-font-medium"
                        fontSize="ltw-text-15"
                        lineHeight="ltw-leading-16"
                        color="ltw-text-black"
                        cursor="pointer"
                      >
                        Download HyperExecute CLI
                      </Typography>
                      {/* <span>
                          <Icon name="info-gray" width="13" height="13" />
                        </span> */}
                    </div>
                    <Typography
                      variant="subtext-1"
                      color="ltw-text-gray-4"
                      fontType="ltw-font-normal"
                      className="ltw-tracking-widest"
                      fontSize="ltw-text-12"
                      lineHeight="ltw-leading-19"
                      cursor="pointer"
                    >
                      CLI is a command line interface to interact and run tests.
                      It is recommended to place the CLI in the project root
                      directory.
                    </Typography>
                  </div>
                  <div
                    className={`${
                      activeEventKeyHypertestCli === 0
                        ? 'ltw-transform ltw-rotate-180'
                        : ''
                    }`}
                  >
                    <Icon
                      name={'expand-arrow'}
                      width="7"
                      height="12"
                      className="ltw-transform ltw-rotate-90"
                    />
                  </div>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={0} className="ltw-pt-17px">
                <div className="ltw-flex ltw-items-center ltw-flex-wrap ltw-gap-30px">
                  <div className="ltw-flex ltw-items-center ltw-gap-12px">
                    <a
                      onClick={(e) => downloadConcierge(systemOS)}
                      href={getConciergeURL(systemOS)}
                      className={
                        'ltw-flex ltw-items-center ltw-bg-transparent ltw-border ltw-border-primary hover:ltw-border-primary hover:ltw-bg-primary ltw-rounded ltw-px-10px ltw-py-6px onboarding-cta-btn'
                      }
                    >
                      <Icon
                        name={getSystemOsIcon()}
                        width="14px"
                        height="16px"
                        color="#0ebac5"
                        className={'ltw-mr-8px ltw-inline-block'}
                      />
                      <Typography
                        variant="h2"
                        color="ltw-text-primary hover:ltw-text-white"
                        fontSize="ltw-text-12"
                        lineHeight="ltw-leading-12"
                        fontType="ltw-font-normal"
                        cursor="pointer"
                        extraClasses="ltw-flex"
                      >
                        {getSystemOsName()}
                      </Typography>
                      <Icon
                        name="download-icon"
                        width="10px"
                        height="12px"
                        color="#0ebac5"
                        className={'ltw-ml-6px ltw-inline-block'}
                      />
                    </a>
                  </div>
                  <div className="ltw-flex ltw-gap-11px ltw-items-center">
                    <Typography
                      variant="h2"
                      fontType="ltw-font-normal"
                      fontSize="ltw-text-10"
                      lineHeight="ltw-leading-12"
                      color="ltw-text-black-secondary"
                    >
                      Other OS?
                    </Typography>
                    <div className="ltw-flex ltw-gap-8px ltw-items-center">
                      {getOthersOS().map((osName, index) => {
                        return (
                          <a
                            className="ltw-flex ltw-items-center ltw-gap-8px ltw-bg-gray-btn ltw-px-10px ltw-py-6px ltw-rounded  platformaBtn"
                            onClick={(e) => downloadConcierge(osName)}
                            href={getConciergeURL(osName)}
                          >
                            <Icon
                              name={getSystemOsIcon(osName)}
                              width="14px"
                              height="16px"
                            />
                            <span className="otherOsName">
                              <Typography
                                variant="h2"
                                color="ltw-black-secondary"
                                fontSize="ltw-text-12"
                                lineHeight="ltw-leading-12"
                                fontType="ltw-font-normal"
                                cursor="pointer"
                                extraClasses="ltw-flex"
                              >
                                {getSystemOsName(osName)}
                              </Typography>
                            </span>
                            <span className="otherOsName">
                              <Icon
                                name="download-icon"
                                width="10px"
                                height="12px"
                                color="#666666"
                              />
                            </span>
                          </a>
                        );
                      })}
                    </div>
                  </div>
                </div>
                {currentConfigurationYamlBased.currentStep === 1 && (
                  <div
                    onClick={(e) => {
                      updateCompletedSteps(['download_concierge'], 2);
                      sendAmplitudeEvents(
                        EventNames.HYP_ONBOARDING_SKIP_STEPS_YAML,
                        {
                          step: 'download cli',
                        }
                      );
                    }}
                    onKeyDown={(e) =>
                      isEnterPressed(e) &&
                      updateCompletedSteps(['download_concierge'], 2)
                    }
                    role="button"
                    tabIndex="0"
                    className={'ltw-flex ltw-justify-end'}
                  >
                    <Typography
                      variant="h2"
                      color="ltw-text-primary"
                      fontSize="ltw-text-13"
                      lineHeight="ltw-leading-16"
                      fontType="ltw-font-normal"
                      cursor="pointer"
                      extraClasses="ltw-flex"
                    >
                      Skip
                    </Typography>
                  </div>
                )}
              </Accordion.Collapse>
            </Accordion>
          </div>
          <div
            className="ltw-flex ltw-relative"
            disableddiv={
              currentConfigurationYamlBased.completedSteps.indexOf(
                'download_concierge'
              ) === -1 && currentConfigurationYamlBased.currentStep !== 2
                ? 'disabled'
                : 'false'
            }
          >
            <div
              className={`ltw-border-l ltw-border-dashed ltw-border-opacity-40  ${
                currentConfigurationYamlBased.completedSteps.indexOf(
                  'platform_changed'
                ) !== -1 &&
                currentConfigurationYamlBased.completedSteps.indexOf(
                  'concurrency_changed'
                ) !== -1
                  ? 'ltw-border-primary'
                  : 'ltw-border-gray-7'
              }`}
            >
              <span
                className={`ltw-border-2 ltw-rounded-5px ${
                  currentConfigurationYamlBased.currentStep === 2 ||
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'download_concierge'
                  ) !== -1
                    ? 'ltw-border-primary'
                    : 'ltw-border-gray-7'
                } ltw-w-8px ltw-h-8px ltw-absolute ltw-right-full ltw-left-minus4px ${
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'platform_changed'
                  ) !== -1 &&
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'concurrency_changed'
                  ) !== -1
                    ? 'ltw-bg-primary'
                    : ' ltw-bg-white'
                } ltw-mt-40px`}
              ></span>
            </div>
            <Accordion
              activeEventKey={activeEventKeyUserSetting}
              onToggle={setActiveEventKeyAccordianUserSetting}
              className="ltw-ml-18px ltw-p-20px ltw-mt-14px ltw-rounded-lg ltw-bg-white ltw-shadow-onboarding-step ltw-flex-1"
            >
              <Accordion.Toggle eventKey={0}>
                <div className="ltw-flex ltw-items-center">
                  <div className="ltw-flex-1 ltw-cursor-pointer">
                    <div className="ltw-flex ltw-gap-8px ltw-items-center">
                      <Typography
                        variant="h2"
                        fontType="ltw-font-medium"
                        fontSize="ltw-text-15"
                        lineHeight="ltw-leading-16"
                        cursor="pointer"
                        color="ltw-text-black"
                      >
                        Operating System (OS) selection
                      </Typography>
                    </div>
                    <Typography
                      variant="subtext-1"
                      color="ltw-text-gray-4"
                      fontType="ltw-font-normal"
                      className="ltw-tracking-widest"
                      fontSize="ltw-text-12"
                      lineHeight="ltw-leading-19"
                      cursor="pointer"
                    >
                      Choose the preferred OS on which you would like to run the
                      tests
                    </Typography>
                  </div>
                  <div
                    className={`${
                      activeEventKeyUserSetting === 0
                        ? 'ltw-transform ltw-rotate-180'
                        : ''
                    }`}
                  >
                    <Icon
                      name={'expand-arrow'}
                      width="7"
                      height="12"
                      className="ltw-transform ltw-rotate-90"
                    />
                  </div>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={0}>
                <div className="ltw-mt-25px ltw-flex ltw-justify-between ltw-flex-wrap ltw-gap-10px">
                  <div className="ltw-flex ltw-gap-12px ltw-flex-1">
                    <button
                      onClick={(e) => setPlatform('win')}
                      className={`ltw-bg-transparent ${
                        currentConfiguration.platform === 'win'
                          ? 'ltw-border-primary ltw-bg-primary ltw-bg-opacity-10'
                          : 'hover:ltw-border-primary ltw-bg-gray-btn'
                      } ltw-rounded ltw-px-10px ltw-py-6px `}
                    >
                      <Typography
                        variant="h2"
                        color={`${
                          currentConfiguration.platform === 'win'
                            ? 'ltw-text-primary'
                            : 'ltw-text-black-secondary'
                        }`}
                        fontSize="ltw-text-12"
                        lineHeight="ltw-leading-12"
                        fontType="ltw-font-normal"
                        cursor="pointer"
                        extraClasses="ltw-flex"
                      >
                        <Icon
                          name="onboard/windows"
                          width="14px"
                          height="16px"
                          className={'ltw-mx-5px ltw-inline-block'}
                          color={
                            currentConfiguration.platform === 'win'
                              ? '#0ebac5'
                              : ''
                          }
                        />
                        Windows
                      </Typography>
                    </button>
                    {isLinuxSupported && (
                      <button
                        onClick={(e) => setPlatform('linux')}
                        className={`ltw-bg-transparent ${
                          currentConfiguration.platform === 'linux'
                            ? 'ltw-border-primary ltw-bg-primary ltw-bg-opacity-10'
                            : 'hover:ltw-border-primary ltw-bg-gray-btn'
                        } ltw-rounded ltw-px-12px ltw-py-8px `}
                      >
                        <Typography
                          variant="h2"
                          color={`${
                            currentConfiguration.platform === 'linux'
                              ? 'ltw-text-primary'
                              : 'ltw-text-black-secondary'
                          }`}
                          fontSize="ltw-text-12"
                          lineHeight="ltw-leading-12"
                          fontType="ltw-font-normal"
                          cursor="pointer"
                          extraClasses="ltw-flex"
                        >
                          <Icon
                            name="onboard/linux"
                            width="14px"
                            height="16px"
                            className={'ltw-mx-5px ltw-inline-block'}
                            color={
                              currentConfiguration.platform === 'linux'
                                ? '#0A7BFF'
                                : ''
                            }
                          />
                          Linux
                        </Typography>
                      </button>
                    )}
                  </div>
                  <div className="ltw-flex-1">
                    <div className="ltw-flex ltw-justify-between ltw-items-cente ltw-gap-20px">
                      <div className="ltw-flex-1">
                        <Typography
                          variant="subtext-1"
                          color="ltw-text-black-secondary"
                          fontType="ltw-font-medium"
                          fontSize="ltw-text-12"
                          lineHeight="ltw-leading-12"
                        >
                          Concurrency
                        </Typography>
                        <div class="w-1/2">
                          <div className="input-range-container">
                            <InputRange
                              maxValue={
                                concurrency &&
                                concurrency.data &&
                                concurrency.data.data &&
                                concurrency.data.data.total
                              }
                              minValue={1}
                              value={currentConfigurationYamlBased.concurrency}
                              onChange={(val) => {
                                changeConcurrency(val, 'slider');
                              }}
                              onChangeComplete={(value) => {
                                sendAmplitudeEvents(
                                  EventNames.HYP_ONBOARDING_HYPEREXECUTE_UPDATE_CONCURENCY_YAML,
                                  {
                                    value: value,
                                  }
                                );
                              }}
                            />
                          </div>

                          {/* <input
                            type="range"
                            // list="tickmarks"
                            // className="__range"
                            value={currentConfigurationYamlBased.concurrency}
                            min="0"
                            max={
                              concurrency &&
                              concurrency.data &&
                              concurrency.data.data &&
                              concurrency.data.data.total
                            }
                            className="ltw-w-full ltw-cursor-pointer"
                            onChange={(val) => changeConcurrency(val)}
                          /> */}
                        </div>
                      </div>
                      <div className="ltw-px-15px ltw-py-8px ltw-border ltw-border-black-light ltw-rounded ltw-flex ltw-items-center">
                        {/* <Typography
                          variant="subtext-1"
                          color="ltw-text-black-light"
                          fontType="ltw-font-medium"
                          fontSize="ltw-text-12"
                          lineHeight="ltw-leading-12"
                        >
                          {currentConfigurationYamlBased.concurrency}
                        </Typography> */}
                        <input
                          type="number"
                          className="ltw-text-black-light ltw-font-medium ltw-text-12 ltw-leading-12 ltw-w-20px focus:ltw-outline-none ltw-text-center"
                          value={concurrencyInputFieldValue}
                          onChange={(e) => changeConcurrency(e, 'input')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  onClick={(e) => {
                    updateCompletedSteps(
                      ['concurrency_changed', 'platform_changed'],
                      3
                    );
                    sendAmplitudeEvents(
                      EventNames.HYP_ONBOARDING_SKIP_STEPS_YAML,
                      {
                        step: 'os selection',
                      }
                    );
                  }}
                  onKeyDown={(e) =>
                    isEnterPressed(e) &&
                    updateCompletedSteps(
                      ['concurrency_changed', 'platform_changed'],
                      3
                    )
                  }
                  role="button"
                  tabIndex="0"
                  className={'ltw-flex ltw-justify-end ltw-mt-5px'}
                >
                  <Typography
                    variant="h2"
                    color="ltw-text-primary"
                    fontSize="ltw-text-13"
                    lineHeight="ltw-leading-16"
                    fontType="ltw-font-normal"
                    cursor="pointer"
                    extraClasses="ltw-flex"
                  >
                    Skip
                  </Typography>
                </div>
              </Accordion.Collapse>
            </Accordion>
          </div>
          <div
            className="ltw-flex ltw-relative"
            disableddiv={
              currentConfigurationYamlBased.completedSteps.indexOf(
                'concurrency_changed'
              ) === -1 &&
              currentConfigurationYamlBased.completedSteps.indexOf(
                'platform_changed'
              ) === -1 &&
              currentConfigurationYamlBased.currentStep !== 3
                ? 'disabled'
                : 'false'
            }
          >
            <div
              className={`ltw-border-l ltw-border-dashed ltw-border-opacity-40 ${
                currentConfigurationYamlBased.completedSteps.indexOf(
                  'retry_changed'
                ) !== -1 &&
                currentConfigurationYamlBased.completedSteps.indexOf(
                  'timeout_changed'
                ) !== -1
                  ? 'ltw-border-primary'
                  : 'ltw-border-gray-7'
              }`}
            >
              <span
                className={`ltw-border-2 ltw-rounded-5px ${
                  currentConfigurationYamlBased.currentStep === 3 ||
                  (currentConfigurationYamlBased.completedSteps.indexOf(
                    'concurrency_changed'
                  ) !== -1 &&
                    currentConfigurationYamlBased.completedSteps.indexOf(
                      'platform_changed'
                    ) !== -1)
                    ? 'ltw-border-primary'
                    : 'ltw-border-gray-7'
                } ltw-w-8px ltw-h-8px ltw-absolute ltw-right-full ltw-left-minus4px ${
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'retry_changed'
                  ) !== -1 &&
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'timeout_changed'
                  ) !== -1
                    ? 'ltw-bg-primary'
                    : ' ltw-bg-white'
                } ltw-mt-40px `}
              ></span>
            </div>
            <Accordion
              activeEventKey={activeEventKeyTimeout}
              onToggle={setActiveEventKeyAccordianTimeout}
              className="ltw-ml-18px ltw-p-20px ltw-mt-14px ltw-rounded-lg ltw-bg-white ltw-shadow-onboarding-step ltw-flex-1"
            >
              <Accordion.Toggle eventKey={0}>
                <div className="ltw-flex ltw-items-center">
                  <div className="ltw-flex-1 ltw-cursor-pointer">
                    <div className="ltw-flex ltw-gap-8px ltw-items-center">
                      <Typography
                        variant="h2"
                        fontType="ltw-font-medium"
                        fontSize="ltw-text-15"
                        lineHeight="ltw-leading-16"
                        color="ltw-text-black"
                        cursor="pointer"
                      >
                        Retry and Timeout
                      </Typography>
                    </div>
                    <Typography
                      variant="subtext-1"
                      color="ltw-text-gray-4"
                      fontType="ltw-font-normal"
                      className="ltw-tracking-widest"
                      fontSize="ltw-text-12"
                      lineHeight="ltw-leading-19"
                      cursor="pointer"
                    >
                      Number of retries and Total time in minutes after which
                      test execution should stop
                    </Typography>
                  </div>
                  <div
                    className={`${
                      activeEventKeyTimeout === 0
                        ? 'ltw-transform ltw-rotate-180'
                        : ''
                    }`}
                  >
                    <Icon
                      name={'expand-arrow'}
                      width="7"
                      height="12"
                      className="ltw-transform ltw-rotate-90"
                    />
                  </div>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={0}>
                <div className="ltw-mt-25px ltw-flex ltw-justify-between ltw-gap-15px ltw-flex-wrap">
                  <div className="ltw-flex-1">
                    <div className="ltw-flex ltw-justify-between ltw-items-cente ltw-gap-20px">
                      <div className="ltw-flex-1">
                        <Typography
                          variant="subtext-1"
                          color="ltw-text-black-secondary"
                          fontType="ltw-font-medium"
                          fontSize="ltw-text-12"
                          lineHeight="ltw-leading-12"
                        >
                          Retry
                        </Typography>
                        <div class="w-1/2">
                          <div className="input-range-container">
                            <InputRange
                              maxValue={5}
                              minValue={0}
                              value={currentConfigurationYamlBased.retry}
                              onChange={(val) => {
                                changeRetry(val, 'slider');
                              }}
                              onChangeComplete={(value) => {
                                sendAmplitudeEvents(
                                  EventNames.HYP_ONBOARDING_HYPEREXECUTE_UPDATE_RETRY_AND_TIMEOUT_YAML,
                                  {
                                    attribute: 'retry',
                                    value: value,
                                  }
                                );
                              }}
                            />
                          </div>
                          {/* <input
                            type="range"
                            value={currentConfigurationYamlBased.retry}
                            min="0"
                            max="5"
                            className="ltw-w-full ltw-cursor-pointer"
                            onChange={(val) => changeRetry(val)}
                          /> */}
                        </div>
                      </div>
                      <div className="ltw-px-15px ltw-py-8px ltw-border ltw-border-black-light ltw-rounded ltw-flex ltw-items-center">
                        <input
                          type="number"
                          className="ltw-text-black-light ltw-font-medium ltw-text-12 ltw-leading-12 ltw-w-20px focus:ltw-outline-none ltw-text-center"
                          value={retryInputFieldValue}
                          onChange={(e) => changeRetry(e, 'input')}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ltw-flex-1">
                    <div className="ltw-flex ltw-justify-between ltw-items-center ltw-gap-20px">
                      <div className="ltw-flex-1">
                        <Typography
                          variant="subtext-1"
                          color="ltw-text-black-secondary"
                          fontType="ltw-font-medium"
                          fontSize="ltw-text-12"
                          lineHeight="ltw-leading-12"
                        >
                          Timeout
                        </Typography>
                        <div class="w-1/2">
                          <div className="input-range-container">
                            <InputRange
                              maxValue={150}
                              minValue={1}
                              value={currentConfigurationYamlBased.timeout}
                              onChange={(val) => {
                                changeTimeout(val, 'slider');
                              }}
                              onChangeComplete={(value) => {
                                sendAmplitudeEvents(
                                  EventNames.HYP_ONBOARDING_HYPEREXECUTE_UPDATE_RETRY_AND_TIMEOUT_YAML,
                                  {
                                    attribute: 'timeout',
                                    value: value,
                                  }
                                );
                              }}
                            />
                          </div>
                          {/* <input
                            type="range"
                            value={currentConfigurationYamlBased.timeout}
                            min="0"
                            max="150"
                            className="ltw-w-full ltw-cursor-pointer"
                            onChange={(val) => changeTimeout(val)}
                          /> */}
                        </div>
                      </div>
                      <div className="ltw-px-15px ltw-py-8px ltw-border ltw-border-black-light ltw-rounded ltw-flex ltw-items-center">
                        <input
                          type="number"
                          className="ltw-text-black-light ltw-font-medium ltw-text-12 ltw-leading-12 ltw-w-20px focus:ltw-outline-none ltw-text-center"
                          value={timeoutInputFieldValue}
                          onChange={(e) => changeTimeout(e, 'input')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  onClick={(e) => {
                    updateCompletedSteps(
                      ['retry_changed', 'timeout_changed'],
                      4
                    );
                    sendAmplitudeEvents(
                      EventNames.HYP_ONBOARDING_SKIP_STEPS_YAML,
                      {
                        step: 'retry and timeout',
                      }
                    );
                  }}
                  onKeyDown={(e) =>
                    isEnterPressed(e) &&
                    updateCompletedSteps(
                      ['retry_changed', 'timeout_changed'],
                      4
                    )
                  }
                  role="button"
                  tabIndex="0"
                  className={'ltw-flex ltw-justify-end ltw-mt-5px'}
                >
                  <Typography
                    variant="h2"
                    color="ltw-text-primary"
                    fontSize="ltw-text-13"
                    lineHeight="ltw-leading-16"
                    fontType="ltw-font-normal"
                    cursor="pointer"
                    extraClasses="ltw-flex"
                  >
                    Skip
                  </Typography>
                </div>
              </Accordion.Collapse>
            </Accordion>
          </div>
          <div
            className="ltw-flex ltw-relative"
            disableddiv={
              currentConfigurationYamlBased.completedSteps.indexOf(
                'retry_changed'
              ) === -1 &&
              currentConfigurationYamlBased.completedSteps.indexOf(
                'timeout_changed'
              ) === -1 &&
              currentConfigurationYamlBased.currentStep !== 4
                ? 'disabled'
                : 'false'
            }
          >
            <div
              className={`ltw-border-l ltw-border-dashed ltw-border-opacity-40 ${
                currentConfigurationYamlBased.completedSteps.indexOf(
                  'test_discovery_changed'
                ) !== -1
                  ? 'ltw-border-primary'
                  : 'ltw-border-gray-7'
              }`}
            >
              <span
                className={`ltw-border-2 ltw-rounded-5px ${
                  currentConfigurationYamlBased.currentStep === 4 ||
                  (currentConfigurationYamlBased.completedSteps.indexOf(
                    'timeout_changed'
                  ) !== -1 &&
                    currentConfigurationYamlBased.completedSteps.indexOf(
                      'retry_changed'
                    ) !== -1)
                    ? 'ltw-border-primary'
                    : 'ltw-border-gray-7'
                } ltw-w-8px ltw-h-8px ltw-absolute ltw-right-full ltw-left-minus4px ${
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'test_discovery_changed'
                  ) !== -1
                    ? 'ltw-bg-primary'
                    : ' ltw-bg-white'
                } ltw-mt-40px`}
              ></span>
            </div>
            <Accordion
              activeEventKey={activeEventKeyTestDiscovery}
              onToggle={setActiveEventKeyTestDiscovery}
              className="ltw-ml-18px ltw-p-20px ltw-mt-14px ltw-rounded-lg ltw-bg-white ltw-shadow-onboarding-step ltw-flex-1"
            >
              <Accordion.Toggle eventKey={0}>
                <div className="ltw-flex ltw-items-center">
                  <div className="ltw-flex-1 ltw-cursor-pointer">
                    <div className="ltw-flex ltw-gap-8px ltw-items-center">
                      <Typography
                        variant="h2"
                        fontType="ltw-font-medium"
                        fontSize="ltw-text-15"
                        color="ltw-text-black"
                        lineHeight="ltw-leading-16"
                        cursor="pointer"
                      >
                        Test Discovery
                      </Typography>
                    </div>
                    <Typography
                      variant="subtext-1"
                      color="ltw-text-gray-4"
                      fontType="ltw-font-normal"
                      className="ltw-tracking-widest"
                      fontSize="ltw-text-12"
                      lineHeight="ltw-leading-19"
                      cursor="pointer"
                      mb="10px"
                    >
                      Path discovering (or locating) relevant tests via
                      classnames, filters, filenames
                    </Typography>
                  </div>
                  <div
                    className={`${
                      activeEventKeyTestDiscovery === 0
                        ? 'ltw-transform ltw-rotate-180'
                        : ''
                    }`}
                  >
                    <Icon
                      name={'expand-arrow'}
                      width="7"
                      height="12"
                      className="ltw-transform ltw-rotate-90"
                    />
                  </div>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={0}>
                <div className="yml-related-cmd">
                  <CodeMirror
                    value={currentConfigurationYamlBased.testdiscovery}
                    options={{
                      mode: { name: 'javascript', json: true },
                      theme: 'material',
                      // lineNumbers: true,
                      lineWrapping: true,
                      indentWithTabs: false,
                      lint: {
                        highlightLines: true,
                      },
                      gutters: ['CodeMirror-lint-markers'],
                      readOnly:
                        staticDiscoveryCmdFramework.indexOf(
                          `${currentConfiguration?.framework?.name}-${currentConfiguration?.frameworkType}`
                        ) !== -1
                          ? true
                          : false,
                      autofocus:
                        staticDiscoveryCmdFramework.indexOf(
                          `${currentConfiguration?.framework?.name}-${currentConfiguration?.frameworkType}`
                        ) !== -1
                          ? false
                          : true,
                    }}
                    onBeforeChange={(editor, data, value) => {
                      updateTestDiscovery(value);
                      sendAmplitudeEvents(
                        EventNames.HYP_ONBOARDING_HYPEREXECUTE_UPDATE_DISCOVERY_YAML
                      );
                    }}
                    // onChange={(editor, data, value) => {}}
                  />
                </div>
                <div
                  onClick={(e) => {
                    updateCompletedSteps(['test_discovery_changed'], 5);
                    sendAmplitudeEvents(
                      EventNames.HYP_ONBOARDING_SKIP_STEPS_YAML,
                      {
                        step: 'test discovery',
                      }
                    );
                  }}
                  onKeyDown={(e) =>
                    isEnterPressed(e) &&
                    updateCompletedSteps(['test_discovery_changed'], 5)
                  }
                  role="button"
                  tabIndex="0"
                  className={'ltw-flex ltw-justify-end ltw-mt-5px'}
                >
                  <Typography
                    variant="h2"
                    color="ltw-text-primary"
                    fontSize="ltw-text-13"
                    lineHeight="ltw-leading-16"
                    fontType="ltw-font-normal"
                    cursor="pointer"
                    extraClasses="ltw-flex"
                  >
                    Skip
                  </Typography>
                </div>
              </Accordion.Collapse>
            </Accordion>
          </div>
          <div
            className="ltw-flex ltw-relative"
            disableddiv={
              currentConfigurationYamlBased.completedSteps.indexOf(
                'test_discovery_changed'
              ) === -1 && currentConfigurationYamlBased.currentStep !== 5
                ? 'disabled'
                : 'false'
            }
          >
            <div
              className={`ltw-border-l ltw-border-dashed ltw-border-opacity-40 ${
                currentConfigurationYamlBased.completedSteps.indexOf(
                  'test_runner_changed'
                ) !== -1
                  ? 'ltw-border-primary'
                  : 'ltw-border-gray-7'
              } `}
            >
              <span
                className={`ltw-border-2 ltw-rounded-5px ${
                  currentConfigurationYamlBased.currentStep === 5 ||
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'test_discovery_changed'
                  ) !== -1
                    ? 'ltw-border-primary'
                    : 'ltw-border-gray-7'
                } ltw-w-8px ltw-h-8px ltw-absolute ltw-right-full ltw-left-minus4px ${
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'test_runner_changed'
                  ) !== -1
                    ? 'ltw-bg-primary'
                    : ' ltw-bg-white'
                } ltw-mt-40px `}
              ></span>
            </div>
            <Accordion
              activeEventKey={activeEventKeyTestRunner}
              onToggle={setActiveEventKeyTestRunner}
              className="ltw-ml-18px ltw-p-20px ltw-mt-14px ltw-rounded-lg ltw-bg-white ltw-shadow-onboarding-step ltw-flex-1"
            >
              <Accordion.Toggle eventKey={0}>
                <div className="ltw-flex ltw-items-center">
                  <div className="ltw-flex-1 ltw-cursor-pointer">
                    <div className="ltw-flex ltw-gap-8px ltw-items-center">
                      <Typography
                        variant="h2"
                        fontType="ltw-font-medium"
                        fontSize="ltw-text-15"
                        color="ltw-text-black"
                        lineHeight="ltw-leading-16"
                        cursor="pointer"
                      >
                        Test Runner Command
                      </Typography>
                    </div>
                    <Typography
                      variant="subtext-1"
                      color="ltw-text-gray-4"
                      fontType="ltw-font-normal"
                      className="ltw-tracking-widest"
                      fontSize="ltw-text-11"
                      lineHeight="ltw-leading-19"
                      cursor="pointer"
                      mb="10px"
                    >
                      Command to trigger the test execution
                    </Typography>
                  </div>
                  <div
                    className={`${
                      activeEventKeyTestRunner === 0
                        ? 'ltw-transform ltw-rotate-180'
                        : ''
                    }`}
                  >
                    <Icon
                      name={'expand-arrow'}
                      width="7"
                      height="12"
                      className="ltw-transform ltw-rotate-90"
                    />
                  </div>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={0}>
                <div className="yml-related-cmd">
                  <CodeMirror
                    value={currentConfigurationYamlBased.testRunner}
                    options={{
                      mode: { name: 'javascript', json: true },
                      theme: 'material',
                      // lineNumbers: true,
                      lineWrapping: true,
                      indentWithTabs: false,
                      lint: {
                        highlightLines: true,
                      },
                      readOnly:
                        staticTestRunnerCmdFramework.indexOf(
                          `${currentConfiguration?.framework?.name}-${currentConfiguration?.frameworkType}`
                        ) !== -1
                          ? true
                          : false,
                      gutters: ['CodeMirror-lint-markers'],
                      autofocus:
                        staticTestRunnerCmdFramework.indexOf(
                          `${currentConfiguration?.framework?.name}-${currentConfiguration?.frameworkType}`
                        ) !== -1
                          ? false
                          : true,
                    }}
                    onBeforeChange={(editor, data, value) => {
                      updateTestRunner(value);
                      sendAmplitudeEvents(
                        EventNames.HYP_ONBOARDING_HYPEREXECUTE_UPDATE_TEST_RUNNER_YAML
                      );
                    }}
                    // onChange={(editor, data, value) => {}}
                  />
                </div>
                {currentConfigurationYamlBased.currentStep === 5 && (
                  <div
                    onClick={(e) => {
                      updateCompletedSteps(['test_runner_changed'], 6);
                      sendAmplitudeEvents(
                        EventNames.HYP_ONBOARDING_SKIP_STEPS_YAML,
                        {
                          step: 'test runner command',
                        }
                      );
                    }}
                    onKeyDown={(e) =>
                      isEnterPressed(e) &&
                      updateCompletedSteps(['test_runner_changed'], 6)
                    }
                    role="button"
                    tabIndex="0"
                    className={'ltw-flex ltw-justify-end ltw-mt-5px'}
                  >
                    <Typography
                      variant="h2"
                      color="ltw-text-primary"
                      fontSize="ltw-text-13"
                      lineHeight="ltw-leading-16"
                      fontType="ltw-font-normal"
                      cursor="pointer"
                      extraClasses="ltw-flex"
                    >
                      Skip
                    </Typography>
                  </div>
                )}
              </Accordion.Collapse>
            </Accordion>
          </div>

          <div className="ltw-flex ltw-relative">
            <div
              className={`ltw-border-l ltw-border-dashed ltw-border-opacity-40 ltw-mb-50px  ${
                currentConfigurationYamlBased.currentStep === 6
                  ? 'ltw-border-primary'
                  : 'ltw-border-gray-7'
              }`}
            >
              <span
                className={`ltw-border-2 ltw-rounded-5px ${
                  currentConfigurationYamlBased.currentStep === 6 ||
                  currentConfigurationYamlBased.completedSteps.indexOf(
                    'test_runner_changed'
                  ) !== -1
                    ? 'ltw-border-primary'
                    : 'ltw-border-gray-7'
                } ltw-w-8px ltw-h-8px ltw-absolute ltw-right-full ltw-left-minus4px ltw-bg-white ltw-mt-40px`}
              ></span>
            </div>
            <Accordion
              activeEventKey={activeEventKeyTestRunCmd}
              onToggle={setActiveEventKeyTestRunCmd}
              className="ltw-ml-18px ltw-p-20px ltw-mt-14px ltw-rounded-lg ltw-bg-white ltw-shadow-onboarding-step ltw-flex-1"
            >
              <Accordion.Toggle eventKey={0}>
                <div className="ltw-flex ltw-items-center">
                  <div className="ltw-flex-1 ltw-cursor-pointer">
                    <div className="ltw-flex ltw-gap-8px ltw-items-center">
                      <Typography
                        variant="h2"
                        fontType="ltw-font-medium"
                        fontSize="ltw-text-15"
                        color="ltw-text-black"
                        lineHeight="ltw-leading-16"
                        cursor="pointer"
                      >
                        Steps to Execute
                      </Typography>
                    </div>
                    <Typography
                      variant="subtext-1"
                      color="ltw-text-gray-4"
                      fontType="ltw-font-normal"
                      className="ltw-tracking-widest"
                      fontSize="ltw-text-12"
                      lineHeight="ltw-leading-19"
                      cursor="pointer"
                      mb="10px"
                    >
                      Please
                      <span
                        className="ltw-px-5px ltw-text-primary"
                        onClick={(e) => {
                          downloadYaml(
                            getYamlCode(
                              currentConfigurationYamlBased
                                .frameworkConfiguration.yamlCode
                            )
                          );
                          copyBtnClicked('download');
                          sendAmplitudeEvents(
                            EventNames.HYP_ONBOARDING_DOWNLOAD_YAML_CODE_YAML
                          );
                        }}
                        onKeyDown={(e) => {
                          isEnterPressed(e) &&
                            downloadYaml(
                              getYamlCode(
                                currentConfigurationYamlBased
                                  .frameworkConfiguration.yamlCode
                              )
                            );
                        }}
                        role="button"
                        tabIndex="0"
                      >
                        Download
                      </span>
                      the YAML file and run the following command in the
                      HyperExecute CLI
                    </Typography>
                  </div>
                  <div
                    className={`${
                      activeEventKeyTestRunCmd === 0
                        ? 'ltw-transform ltw-rotate-180'
                        : ''
                    }`}
                  >
                    <Icon
                      name={'expand-arrow'}
                      width="7"
                      height="12"
                      className="ltw-transform ltw-rotate-90"
                    />
                  </div>
                </div>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey={0}>
                <div className="ltw-relative">
                  <ReactTooltip id="accordian" />
                  <div className="ltw-absolute ltw-right-10px ltw-top-20px ltw-cursor-pointer ltw-z-10">
                    {testRunnerCmdCopy === false ? (
                      <CopyToClipboard
                        text={
                          currentConfigurationYamlBased &&
                          currentConfigurationYamlBased.frameworkConfiguration &&
                          getCommandToRunTest(
                            currentConfigurationYamlBased.frameworkConfiguration
                              ?.runTestCommand
                          )
                        }
                        onCopy={() => {
                          copyBtnClickedTestRunner();
                          sendAmplitudeEvents(
                            EventNames.HYP_ONBOARDING_COPY_EXECUTE_CMD_YAML_PAGE
                          );
                        }}
                      >
                        <div data-tip="Copy" data-for="accordian">
                          <Icon name="copy-icon" width="14px" height="14px" />
                        </div>
                      </CopyToClipboard>
                    ) : (
                      <div className=" ltw-bg-green-color-copied ltw-rounded ltw-py-5px ltw-px-10px ltw-flex ltw-justify-center  ltw-max-w-220px ltw-cursor-pointer">
                        <div className="ltw-flex ltw-justify-center">
                          <Typography
                            variant="subtext-1"
                            color="ltw-text-black-regular"
                            cursor="pointer"
                            fontType="ltw-font-normal"
                          >
                            Copied
                          </Typography>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="github-clone-code">
                    <CodeMirror
                      value={
                        currentConfigurationYamlBased &&
                        currentConfigurationYamlBased.frameworkConfiguration &&
                        getCommandToRunTest(
                          currentConfigurationYamlBased.frameworkConfiguration
                            .runTestCommand
                        )
                      }
                      options={{
                        mode: 'text/x-yaml',
                        theme: 'material',
                        lineNumbers: false,
                        lineWrapping: true,
                        indentWithTabs: false,
                        lint: {
                          highlightLines: true,
                        },
                        gutters: ['CodeMirror-lint-markers'],
                      }}
                      onChange={(editor, data, value) => {}}
                    />
                  </div>
                </div>
                {(yamlCopied || yamlDownloaded) && (
                  <div className="ltw-bg-red-bg ltw-px-16px ltw-py-9px ltw-mt-8px ltw-mr-50px">
                    {yamlCopied && (
                      <Typography
                        variant="subtext-1"
                        color="ltw-text-red-msg"
                        fontType="ltw-font-normal"
                        className="ltw-tracking-widest"
                        fontSize="ltw-text-12"
                        lineHeight="ltw-leading-19"
                        mt="5px"
                      >
                        <Icon
                          name="info-blue"
                          width="14px"
                          height="14px"
                          color="#FF7663"
                          className="ltw-mb-2px ltw-inline-block ltw-mr-6px"
                        />
                        Please ensure that you put your yaml in the root
                        directory of your project and provide the exact yaml
                        file name in the execute script.
                      </Typography>
                    )}
                    {yamlDownloaded && (
                      <Typography
                        variant="subtext-1"
                        color="ltw-text-red-msg"
                        fontType="ltw-font-normal"
                        className="ltw-tracking-widest"
                        fontSize="ltw-text-12"
                        lineHeight="ltw-leading-19"
                        mt="5px"
                      >
                        <Icon
                          name="info-blue"
                          width="14px"
                          height="14px"
                          color="#FF7663"
                          className="ltw-mb-2px ltw-inline-block ltw-mr-6px"
                        />
                        Please ensure that you put your yaml in the root
                        directory of your project and if renaming it please
                        change the yaml file name in the execute script. By
                        default the file gets downloaded by the name of
                        hyperexecute.yaml
                      </Typography>
                    )}
                  </div>
                )}
                {/* <div className="yml-related-cmd">
                  <CodeMirror
                    value={
                      currentConfigurationYamlBased &&
                      currentConfigurationYamlBased.frameworkConfiguration &&
                      getCommandToRunTest(
                        currentConfigurationYamlBased.frameworkConfiguration
                          .runTestCommand
                      )
                    }
                    options={{
                      mode: { name: 'javascript', json: true },
                      theme: 'material',
                      // lineNumbers: true,
                      lineWrapping: true,
                      indentWithTabs: false,
                      lint: {
                        highlightLines: true,
                      },
                      gutters: ['CodeMirror-lint-markers'],
                    }}
                    onBeforeChange={(editor, data, value) => {
                      // setYamlContent(value);
                    }}
                    // onChange={(editor, data, value) => {}}
                  />
                </div> */}
              </Accordion.Collapse>
            </Accordion>
          </div>
        </div>
        <div className="ltw-flex-1 ltw-relative">
          <div className="ltw-absolute ltw-top-10px ltw-right-30px ltw-z-10 ltw-cursor-pointer">
            {textCopiedType === '' ? (
              <div className="ltw-flex ltw-gap-13px">
                <div
                  className="ltw-flex ltw-items-center"
                  onClick={(e) => {
                    resetYamlCode(e);
                    copyBtnClicked('reset');
                    sendAmplitudeEvents(
                      EventNames.HYP_ONBOARDING_RESET_YAML_CODE_YAML
                    );
                  }}
                  onKeyDown={(e) => isEnterPressed(e) && resetYamlCode(e)}
                  role="button"
                  tabIndex="0"
                  data-tip="Reset"
                  data-for="configure-yaml"
                >
                  <Icon name="reset-icon" width="14px" height="16px" />
                </div>
                <div
                  className="ltw-flex ltw-items-center"
                  onClick={(e) => {
                    downloadYaml(
                      getYamlCode(
                        currentConfigurationYamlBased.frameworkConfiguration
                          .yamlCode
                      )
                    );
                    copyBtnClicked('download');
                    sendAmplitudeEvents(
                      EventNames.HYP_ONBOARDING_COPY_YAML_CODE_YAML,
                      {
                        getUsing: 'download',
                      }
                    );
                  }}
                  onKeyDown={(e) => {
                    isEnterPressed(e) &&
                      downloadYaml(
                        getYamlCode(
                          currentConfigurationYamlBased.frameworkConfiguration
                            ?.yamlCode
                        )
                      );
                  }}
                  role="button"
                  tabIndex="0"
                  data-tip="Download"
                  data-for="configure-yaml"
                >
                  <Icon name="download-icon" width="12px" height="14px" />
                </div>
                <CopyToClipboard
                  data-tip="Copy"
                  data-for="configure-yaml"
                  text={getYamlCode(
                    currentConfigurationYamlBased?.frameworkConfiguration
                      ?.yamlCode
                  )}
                  onCopy={() => {
                    copyBtnClicked('yaml');
                    sendAmplitudeEvents(
                      EventNames.HYP_ONBOARDING_COPY_YAML_CODE_YAML,
                      {
                        getUsing: 'copy',
                      }
                    );
                  }}
                >
                  <div className="ltw-flex ltw-items-center" data-reset="Copy">
                    <Icon name="copy-icon" width="14px" height="14px" />
                  </div>
                </CopyToClipboard>
              </div>
            ) : (
              <div className=" ltw-bg-green-color-copied ltw-rounded ltw-py-5px ltw-px-10px ltw-flex ltw-justify-center  ltw-max-w-220px ltw-cursor-pointer">
                <div className="ltw-flex ltw-justify-center">
                  <Typography
                    variant="subtext-1"
                    color="ltw-text-black-regular"
                    cursor="pointer"
                    fontType="ltw-font-normal"
                  >
                    {textCopiedType === 'yaml' && 'Copied'}
                    {textCopiedType === 'download' && 'Downloaded'}
                    {textCopiedType === 'reset' && 'Reset'}
                  </Typography>
                </div>
              </div>
            )}
          </div>
          <div className="yml-container-large">
            <CodeMirror
              value={getYamlCode(
                currentConfigurationYamlBased.frameworkConfiguration?.yamlCode
              )}
              options={{
                mode: 'text/x-yaml',
                // mode: { name: 'javascript', json: true },

                // theme: '3024-night',
                // theme: 'abcdef',
                // theme: 'ayu-dark',
                theme: 'mytheme',
                lineNumbers: true,
                lineWrapping: true,
                indentWithTabs: false,
                lint: {
                  highlightLines: true,
                },
                gutters: ['CodeMirror-lint-markers'],
              }}
              onBeforeChange={(editor, data, value) => {
                updateYaml(value);
              }}
              onChange={(editor, data, value) => {
                updateYaml(value);
              }}
            />
          </div>
          <div className="ltw-mt-13px ltw-mr-10px ltw-flex ltw-justify-end">
            <Typography
              variant="h2"
              color="ltw-text-black-secondary"
              fontSize="ltw-text-13"
              lineHeight="ltw-leading-15"
            >
              Please note that we have selected
              <a
                className="ltw-text-primary ltw-mx-2px"
                target={'_blank'}
                href="https://www.lambdatest.com/support/docs/deep-dive-into-hyperexecute-yaml#smart-auto-test-splitting"
                onClick={() => {
                  sendAmplitudeEvents(
                    EventNames.HYP_ONBOARDING_HYPEREXECUTE_AUTOSPLIT_STRATIGY_CLICK
                  );
                }}
                rel="noreferrer"
              >
                Auto Splitting Strategy
              </a>
              <Icon
                name="info-blue"
                width="14"
                height="14"
                className="ltw-inline ltw-mr-2px ltw-mb-2px"
                color="#0ebac5"
              />
              by default to you get started
            </Typography>
          </div>
        </div>
      </div>

      <ViewTestResult />
      {visual && visual.conciergeDownloadAlert && (
        <div className="ltw-fixed ltw-bottom-20px ltw-flex ltw-items-end ltw-gap-20px">
          <Icon name={'quick-start'} width="57" height="68" />
          <div className="ltw-rounded-lg ltw-border ltw-border-secondary ltw-bg-white ltw-w-336px quickStart">
            <div className="ltw-flex ltw-justify-between ltw-bg-secondary ltw-p-15px ltw-gap-5px ltw-items-center">
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontType="ltw-font-semibold"
                fontSize="ltw-text-15"
                lineHeight="ltw-leading-18"
              >
                You have downloaded the CLI for{' '}
                {getSystemOsName(currentConfiguration.conciergePlatform)}
              </Typography>
              <Icon
                name={'close-white'}
                width="14"
                height="16"
                onClick={(e) => {
                  resetDownloadCociergeAlert(false);
                }}
                className="ltw-cursor-pointer"
              />
            </div>
            <div className="ltw-px-20px ltw-py-18px">
              <Typography
                variant="h2"
                color="ltw-text-black-secondary-2"
                fontType="ltw-font-normal"
                fontSize="ltw-text-13"
                lineHeight="ltw-leading-19"
              >
                To make it Executable, please run the following command -
                <b> chmod u+x hyperexecute</b>
              </Typography>
            </div>
            <button
              onClick={(e) => {
                resetDownloadCociergeAlert(false);
              }}
              className="ltw-bg-transparent ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-15px ltw-py-8px ltw-ml-20px ltw-mb-18px"
            >
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontSize="ltw-text-12"
                lineHeight="ltw-leading-12"
                cursor="pointer"
              >
                Okay
              </Typography>
            </button>
          </div>
        </div>
      )}
      {visual && visual.yamlCodeCopiedAlert && (
        <div className="ltw-fixed ltw-bottom-20px ltw-flex ltw-items-end ltw-gap-20px">
          <Icon name={'support-icon'} width="100" height="100" />
          <div className="ltw-rounded-lg ltw-border ltw-border-secondary ltw-bg-white ltw-w-336px quickStart">
            <div className="ltw-flex ltw-justify-between ltw-bg-secondary ltw-p-15px ltw-gap-5px ltw-items-center">
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontType="ltw-font-semibold"
                fontSize="ltw-text-15"
                lineHeight="ltw-leading-18"
              >
                We're here to help
              </Typography>
              <Icon
                name={'close-white'}
                width="14"
                height="16"
                onClick={(e) => {
                  setActiveEventKeyTestRunCmd(0);
                  updateYamlCopyAlertStatus({ yamlCodeCopiedAlert: false });
                }}
                className="ltw-cursor-pointer"
              />
            </div>
            <div className="ltw-px-20px ltw-py-18px">
              <Typography
                variant="h2"
                color="ltw-text-black-secondary-2"
                fontType="ltw-font-normal"
                fontSize="ltw-text-13"
                lineHeight="ltw-leading-19"
              >
                Please ensure that you put your yaml in the root directory of
                your project and provide the exact yaml file name in the execute
                script.
              </Typography>
            </div>
            <button
              onClick={(e) => {
                setActiveEventKeyTestRunCmd(0);
                updateYamlCopyAlertStatus({ yamlCodeCopiedAlert: false });
              }}
              className="ltw-bg-transparent ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-15px ltw-py-8px ltw-ml-20px ltw-mb-18px"
            >
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontSize="ltw-text-12"
                lineHeight="ltw-leading-12"
                cursor="pointer"
              >
                Okay
              </Typography>
            </button>
          </div>
        </div>
      )}
      {visual && visual.yamlCodeDownloadedAlert && (
        <div className="ltw-fixed ltw-bottom-20px ltw-flex ltw-items-end ltw-gap-20px">
          <Icon name={'support-icon'} width="100" height="100" />
          <div className="ltw-rounded-lg ltw-border ltw-border-secondary ltw-bg-white ltw-w-336px quickStart">
            <div className="ltw-flex ltw-justify-between ltw-bg-secondary ltw-p-15px ltw-gap-5px ltw-items-center">
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontType="ltw-font-semibold"
                fontSize="ltw-text-15"
                lineHeight="ltw-leading-18"
              >
                We're here to help
              </Typography>
            </div>
            <div className="ltw-px-20px ltw-py-18px">
              <Typography
                variant="h2"
                color="ltw-text-black-secondary-2"
                fontType="ltw-font-normal"
                fontSize="ltw-text-13"
                lineHeight="ltw-leading-19"
              >
                Please ensure that you put your yaml in the root directory of
                your project and if renaming it please change the yaml file name
                in the execute script.
              </Typography>
            </div>
            <button
              onClick={(e) => {
                sendAmplitudeEvents(EventNames.HYP_CLICK_OKAY_BUTTON_POPUP);
                setActiveEventKeyTestRunCmd(0);
                updateYamlCopyAlertStatus({ yamlCodeDownloadedAlert: false });
              }}
              className="ltw-bg-transparent ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-15px ltw-py-8px ltw-ml-20px ltw-mb-18px"
            >
              <Typography
                variant="h2"
                color="ltw-text-white"
                fontSize="ltw-text-12"
                lineHeight="ltw-leading-12"
                cursor="pointer"
              >
                Okay
              </Typography>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
export default ConfigureTestYamlBased;
